import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, hasRole } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHead } from "@/components/desk/DeskLayout";
import { Button } from "@/components/ui/button";

const STATS = ["draft", "submitted", "approved", "scheduled", "published", "on_hold", "rejected", "withdrawn"];

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({});
  useEffect(() => {
    api.get("/desk/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  const reporterOnly = !hasRole(user, "editor", "news_approver", "reporter_approver");

  return (
    <div data-testid="desk-dashboard">
      <PageHead title={`Hello, ${user.name.split(" ")[0]}`} sub={reporterOnly ? "Track your submissions and feedback." : "Today's newsroom at a glance."}>
        {hasRole(user, "editor", "reporter") && (
          <Button asChild className="rounded-sm" data-testid="dashboard-new-story-btn"><Link to="/desk/stories/new">New story</Link></Button>
        )}
      </PageHead>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {STATS.map((s) => (
          <Link key={s} to={`/desk/stories?status=${s}`} data-testid={`stat-${s}`}
            className="bg-white border border-zinc-200 p-4 hover:border-zinc-900 transition-colors">
            <p className="text-[11px] uppercase tracking-[0.1em] text-zinc-500">{s.replace("_", " ")}</p>
            <p className="font-serif-head text-3xl font-black mt-1">{stats[s] || 0}</p>
          </Link>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-3 mt-6">
        {hasRole(user, "news_approver") && (
          <Link to="/desk/queue" data-testid="dashboard-queue-card" className="bg-[#0B2A5B] text-white p-6 hover:bg-[#123a7a] transition-colors">
            <p className="text-[11px] uppercase tracking-[0.14em] text-zinc-400">Approval queue</p>
            <p className="font-serif-head text-4xl font-black mt-2">{stats.submitted || 0}</p>
            <p className="text-sm text-zinc-300 mt-1">stories waiting for review</p>
          </Link>
        )}
        {hasRole(user, "reporter_approver") && (
          <Link to="/desk/reporters" data-testid="dashboard-reporters-card" className="bg-white border border-zinc-900 p-6 hover:bg-zinc-50 transition-colors">
            <p className="text-[11px] uppercase tracking-[0.14em] text-zinc-500">Reporter applications</p>
            <p className="font-serif-head text-4xl font-black mt-2">{stats.pending_reporters || 0}</p>
            <p className="text-sm text-zinc-500 mt-1">pending review</p>
          </Link>
        )}
      </div>
    </div>
  );
}
